import { useCallback, useMemo, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FieldContextMenu } from "../components";

const EMPTY_SX = Object.freeze({});
const HIGHLIGHT_SX = Object.freeze({
  "&.MuiInputBase-root": {
    backgroundColor: "rgb(255 171 0 / 19%) !important",
  },
});

export const useHighlightableField = () => {
  const { control } = useFormContext();
  const highlightedFields = useWatch({ control, name: "highlightedFields" });

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedField, setSelectedField] = useState(null);

  const highlightedKeys = useMemo(() => {
    const keys = new Set();
    (highlightedFields || []).forEach((f) => keys.add(f.fieldKey));
    return keys;
  }, [highlightedFields]);

  const handleContextMenu = useCallback((e, fieldName) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setSelectedField(fieldName);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuAnchorEl(null);
    setSelectedField(null);
  }, []);

  const getFieldProps = useCallback(
    (name) => ({
      shouldUnregister: false,
      onContextMenu: (e) => handleContextMenu(e, name),
      sx: highlightedKeys.has(name) ? HIGHLIGHT_SX : EMPTY_SX,
    }),
    [handleContextMenu, highlightedKeys],
  );

  const HighlightMenu = (
    <FieldContextMenu
      anchorEl={menuAnchorEl}
      fieldName={selectedField}
      onClose={handleCloseMenu}
    />
  );

  return { HighlightMenu, getFieldProps, highlightedFields: highlightedFields || [] };
};
